<template>
    <div>
        <p class="cp-help-text">
            The print partner is the responsible party for the printed product and the shipping. A reorder can be created of the printed product that contains a production error or was damaged or lost during shipping with a tracked shipping service. Postal service orders do not qualify for reorder due to shipping related issues. Cloudprinter.com and the print partner will check the reorder description and reorder cause and can reject the reorder if the reorder is not qualified.
        </p>

        <br>
        <br>
        <div class="section-header">Select the products for reorder</div>
        <br>
        <template v-if="reorderData.originOrder.items">
            <section>
                <b-collapse
                        class="card"
                        animation="slide"
                        v-for="(item, index) of reorderData.originOrder.items"
                        :key="index"
                        v-if="item.is_reordable === true"
                        aria-id="contentIdForA11y1"
                >
                    <div
                            class="card-header"
                            role="button">
                        <p class="card-header-title" style="padding-left: 23px;">

                            <b-checkbox
                                    slot="trigger"
                                    aria-controls="contentIdForA11y1"
                                    v-model="reorderData.reorderItemsReferences"
                                    :native-value="item.reference"

                            >
                                {{ item.name }} ({{item.reference}})
                            </b-checkbox>
                        </p>
                    </div>
                    <div class="card-content" v-if="reorderData.reorderItemsReferences.indexOf(item.reference) !== -1" style="padding: 20px 22px 34px 31px;">
                        <div class="content">
                            <div class="columns">
                                <div class="column is-half">
                                    <ul style="margin: 0; padding-left: 0.75rem;">
                                        <li v-for="option of item.options" v-bind:key="option.note">
                                          {{option.note}}: {{option.count}}
                                        </li>
                                    </ul>
                                </div>
                                <div class="column is-half reorder-product-quantity" v-if="productsQuantityType">
                                    <template v-if="productsQuantityType[item.reference] === 'range'">
                                        <section>
                                            <b-field custom-class="required-field"
                                                     style="margin: 0"
                                                     :type="{'is-danger': errors.has('general.quantity' + item.reference)}"
                                                     :message="errors.first('general.quantity' + item.reference)"
                                                     :label="'Quantity (' + getQuantityLabelDetail(productsInfo[item.reference], item.count) + ')'">
                                                <b-input v-model="reorderData.productsQuantity[item.reference]"
                                                         v-validate="{required: true, numeric: true, max_value: item.count, min_value: productsInfo[item.reference].quantities.range[0].min}"
                                                         data-vv-scope="general"
                                                         :min="productsInfo[item.reference].quantities.range[0].min"
                                                         :max="item.count"
                                                         type="number"
                                                         :value="item.count"
                                                         data-vv-as="quantity"
                                                         :name="'quantity' + item.reference"></b-input>
                                            </b-field>
                                        </section>
                                    </template>

                                    <template v-if="productsQuantityType[item.reference] === 'fixed'">
                                        <section>
                                            <b-field label="Quantity - The number of copies"
                                                     custom-class="required-field"
                                                     :type="{'is-danger': errors.has('general.quantity' + item.reference)}"
                                                     :message="errors.first('general.quantity' + item.reference)">
                                                <b-select placeholder="Select the quantity"
                                                          expanded
                                                          data-vv-scope="general"
                                                          v-model="reorderData.productsQuantity[item.reference]"
                                                          v-validate="'required'"
                                                          data-vv-as="quantity"
                                                          :name="'quantity' + item.reference">
                                                    <option
                                                            v-for="fixed in productsInfo[item.reference].quantities.fixed"
                                                            v-if="fixed <= item.count"
                                                            :value="fixed"
                                                            :key="fixed">
                                                        {{ fixed }}
                                                    </option>
                                                </b-select>
                                            </b-field>
                                        </section>
                                    </template>

                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </section>
        </template>
        <br>
        <div class="section-header">General reorder info</div>

        <div class="columns">
            <div class="column is-half">
                <b-field
                        label="Reorder cause"
                        :type="{'is-danger': errors.has('general.reorder cause')}"
                        :message="errors.first('general.reorder cause')">
                    <b-select placeholder="Select a cause" expanded
                              v-validate="'required'"
                              v-model="reorderData.reorderCause"
                              data-vv-scope="general"
                              name="reorder cause">
                        <option
                                v-for="cause in reorderCauses"
                                :value="cause.reorder_cause_reference"
                                :key="cause.reorder_cause_reference">
                            {{ cause.note }}
                        </option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Reorder description"
                         :type="{'is-danger': errors.has('general.reorder description')}"
                         :message="errors.first('general.reorder description')">
                    <b-input
                            v-model="reorderData.reorderDescription"
                            data-vv-scope="general"
                            v-validate="'required'"
                            name="reorder description">
                    </b-input>
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
import Cloudprinter from '@/services/CloudprinterService'
import NotificationService from '../../services/NotificationService'
import _ from 'lodash'

export default {
  name: 'StepOne',

  data () {
    return {
      reorderData: {},
      quantityType: false,
      reorderCauses: [],
      isOpen: 0,
      productsInfo: {},
      productsQuantityType: {}
    }
  },

  created () {
    this.$store.dispatch('loader/show')
    this.reorderData = this.$store.getters['cpReorder/allData']
    this.getOriginOrder()
    this.getReorderCauses()
    this.getCountryList()
  },

  methods: {
    getOriginOrder: function () {
      const originOrderReference = decodeURIComponent(this.$route.params.reference + this.$route.hash)
      Cloudprinter.getOrder(originOrderReference.replace('%20', ' '))
        .then((response) => {
          const responseData = response.data
          this.reorderData.originOrder = responseData
          this.setModelData(responseData)
        })
        .catch(() => {
          NotificationService.warning('The order wasn`t found.')
          this.$store.dispatch('loader/hide')
        })
    },

    setModelData: function (responseOrderData) {
      this.reorderData.shippingAddress.street1 = responseOrderData.addresses[0].street1
      this.reorderData.shippingAddress.street2 = responseOrderData.addresses[0].street2
      this.reorderData.shippingAddress.firstName = responseOrderData.addresses[0].firstname
      this.reorderData.shippingAddress.lastName = responseOrderData.addresses[0].lastname
      this.reorderData.shippingAddress.zip = responseOrderData.addresses[0].zip
      this.reorderData.shippingAddress.city = responseOrderData.addresses[0].city
      this.reorderData.shippingAddress.country = responseOrderData.addresses[0].country
      this.reorderData.shippingAddress.state = responseOrderData.addresses[0].state
      this.reorderData.shippingAddress.company = responseOrderData.addresses[0].company
      this.reorderData.shippingAddress.email = responseOrderData.addresses[0].email
      this.reorderData.shippingAddress.phone = responseOrderData.addresses[0].phone
      this.reorderData.shippingAddress.customerIdentification = responseOrderData.addresses[0].customer_identification

      if (responseOrderData.addresses[0].state) {
        this.reorderData.stateIsRequired = true
        this.getStates()
      }

      for (let item of responseOrderData.items) {
        Cloudprinter.getProductInfo(item.product_reference)
          .then(response => {
            this.productsQuantityType[item.reference] = this.getQuantityType(response.data)
            this.productsInfo[item.reference] = response.data
            this.reorderData.productsInfo[item.reference] = response.data
          }).finally(() => {
            this.$store.dispatch('loader/hide')
          })
      }
    },

    getQuantityType: function (productInfo) {
      if (!_.isEmpty(productInfo)) {
        if (_.has(productInfo.quantities, 'fixed')) {
          return 'fixed'
        } else if (_.has(productInfo.quantities, 'range')) {
          return 'range'
        }
      } else {
        return false
      }
    },

    getReorderCauses: function () {
      Cloudprinter.getReorderCauses()
        .then((response) => {
          this.reorderCauses = response.data.reorder_causes
        })
    },

    getCountryList: function () {
      Cloudprinter.getCountries().then((response) => {
        this.reorderData.cpCountries = response.data.shipping_countries
      })
    },

    getStates: function () {
      if (this.reorderData.stateIsRequired) {
        const selectedCountry = this.reorderData.shippingAddress.country

        Cloudprinter.getStates(selectedCountry).then((response) => {
          this.reorderData.cpStates = response.data.shipping_states
        })
      }
    },

    getQuantityLabelDetail: function (productInfo, productOriginQuantity) {
      if (productOriginQuantity === productInfo.quantities.range[0].min) {
        return 'not greater then ' + productOriginQuantity
      } else {
        return productInfo.quantities.range[0].min + '-' + productOriginQuantity
      }
    }
  }
}
</script>
